export default "__VITE_PUBLIC_ASSET__a83a59cc__"